import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import OutputError from "../OutputError";
const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.SOF01.error_id: {
            return row?.data?.map(x => {
                return (
                    <>
                        <ResultText>
                            Ineffective flow areas do not act consistently at the US and DS cross section of {x.type} at RS {x.cross_section} for {x.profiles.join(', ')} profiles.
                        </ResultText>
                    </>
                )
            })
        }
        case MessageCodes.Internal.B30_NOOUT01.error_id: {
            return (
                <>
                    <OutputError error={row}/>
                </>
            )
        }
        case MessageCodes.Internal.B30_NOOUT02.error_id: {
            return (
                <>
                    <OutputError error={row}/>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

export const B30 = {
    RenderDescription,
}